import React from 'react'
import Item from '../Item/Item'
import { Link } from 'react-router-dom'

const NewCollections = (props) => {
  return (
    <div className='flex flex-col items-center py-[100px] px-[8%] relative overflow-hidden bg-gradient-to-b from-white/[0.02] via-white/[0.01] to-transparent border-t border-[rgba(0,212,255,0.08)]'>
      {/* Background accent */}
      <div className="absolute top-1/2 right-1/4 w-[600px] h-[600px] rounded-full blur-[120px] opacity-8 pointer-events-none -z-0" style={{ background: 'radial-gradient(circle, #7c3aed 0%, transparent 70%)' }} />
      
      <div className="w-full max-w-[1400px] relative z-10">
        {/* Header section */}
        <div className="mb-16">
          <div className="flex items-start justify-between flex-wrap gap-6 mb-8">
            <div>
              <span className="inline-block bg-[rgba(124,58,237,0.12)] text-[#a78bfa] border border-[rgba(124,58,237,0.3)] px-4 py-[6px] rounded-full text-[11px] font-bold tracking-[2.5px] uppercase mb-4 backdrop-blur-sm">✨ Fresh Arrivals</span>
              <h2 className="text-[52px] font-black text-white mb-3 -tracking-[1.2px] leading-[1.1] max-[700px]:text-[38px] max-[500px]:text-[28px]">
                LATEST
                <br/>
                <span className="bg-gradient-to-br from-[#7c3aed] via-[#ec4899] to-[#f59e0b] bg-clip-text text-transparent drop-shadow-[0_0_20px_rgba(124,58,237,0.3)]">COLLECTIONS</span>
              </h2>
              <p className="text-[#6b7a8d] text-[15px] leading-[1.6] mt-3">New releases & exclusive drops you can't miss</p>
            </div>
            <div className="flex items-center gap-3">
              <Link to="/phones">
                <button className="px-7 h-12 rounded-[12px] border border-[rgba(124,58,237,0.4)] text-[#a78bfa] text-sm font-bold bg-gradient-to-r from-[rgba(124,58,237,0.08)] to-[rgba(124,58,237,0.02)] hover:from-[rgba(124,58,237,0.15)] hover:to-[rgba(124,58,237,0.08)] transition-all duration-300 cursor-pointer font-[inherit] shadow-lg shadow-purple-900/20 hover:shadow-purple-500/20">
                  Explore All →
                </button>
              </Link>
            </div>
          </div>
          <div className="w-20 h-[4px] bg-gradient-to-r from-[#7c3aed] via-[#ec4899] to-transparent rounded-full" />
        </div>
        
        {/* Products grid */}
        <div className="grid grid-cols-4 gap-5 w-full max-[1300px]:grid-cols-3 max-[900px]:grid-cols-2 max-[600px]:grid-cols-2">
          {props.data.map((item, index) => (
            <Item id={item.id} key={index} name={item.name} image={item.image} new_price={item.new_price} old_price={item.old_price} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default NewCollections
